import * as React from 'react';

import { GraceMockups } from '@/components/products/grace-mockups';
import { ProductCta } from '@/components/products/product-cta';
import { ProductHero } from '@/components/products/product-hero';
import { ProductInsights } from '@/components/products/product-insights';
import { ProductProblem } from '@/components/products/product-problem';
import { ProductSteps } from '@/components/products/product-steps';
import type { ProductPageContent } from '@/content/products';

/**
 * Shared product detail template (spec §4):
 * hero → problem → how it works → insights/proof → optional Grace mockups → CTA.
 */
export function ProductDetailPage({ product }: { product: ProductPageContent }) {
  React.useEffect(() => {
    const previous = document.title;
    document.title = product.documentTitle;
    return () => {
      document.title = previous;
    };
  }, [product.documentTitle]);

  return (
    <article className="flex flex-col">
      <ProductHero product={product} />

      <div className="relative">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-transparent to-[color-mix(in_oklab,var(--background)_70%,transparent)]"
        />
        <div className="bg-background/45 relative backdrop-blur-[1px]">
          <ProductProblem product={product} />
          <ProductSteps product={product} />
          <ProductInsights product={product} />
          {product.showGraceMockups ? <GraceMockups /> : null}
          <ProductCta product={product} />
        </div>
      </div>
    </article>
  );
}
